import * as types from "./mutationTypes";

export default {
  [types.SET_MOBILE](state, isMobile) {
    state.isMobile = isMobile;
  },
  [types.SET_LOADING](state, show) {
    state.loading.show = show;
  },
  [types.HIDE_TOAST](state) {
    state.toast.show = false;
    state.toast.message = null;
  },
  [types.SHOW_TOAST](state, { message, type, timeout }) {
    state.toast.show = true;
    state.toast.message = typeof message === 'object' ? message?.text : message;
    state.toast.sentryTransactionId = typeof message === 'object' ? message?.sentryTransactionId : null;
    state.toast.type = type;
    if (timeout) {
      state.toast.timeout;
    }
  },
  [types.SET_MODAL_PERMISSION](state, { show }) {
    state.modalPermission.show = show;
  }
};
